import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DateTime } from 'luxon';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { PaymentService } from '@amfam/billing/shared/util/lib/services/payment.service';
import type {
  GetPaymentHistoryPayload,
  GetRegisteredPaymentsResponse
} from '@amfam/shared/models/lib/billing/payment-history.models';

import { GetPayments, GetPaymentsFail, GetPaymentsSuccess } from './payment-history.actions';

export const getPaymentHistory = createEffect(
  (action$ = inject(Actions), paymentService = inject(PaymentService)) => {
    return action$.pipe(
      ofType(GetPayments),
      map(action => action.payload),
      mergeMap((payload: GetPaymentHistoryPayload) => {
        const startDate = DateTime.now()
          .minus({ months: payload.monthRange?.startMonth ?? 0 })
          .toFormat('yyyy-MM-dd');
        const endDate = DateTime.now()
          .minus({ months: payload.monthRange?.endMonth ?? 0 })
          .toFormat('yyyy-MM-dd');
        return paymentService.getRegisteredPayments(startDate, endDate, false, true).pipe(
          map((response: GetRegisteredPaymentsResponse) => {
            const payments = response.payments ?? [];
            return GetPaymentsSuccess(payments);
          }),
          catchError(error => {
            if (error?.status?.code === 404) {
              return of(GetPaymentsSuccess([]));
            }
            return of(GetPaymentsFail());
          })
        );
      })
    );
  },
  { functional: true }
);
